<template>
  <!-- 月度指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">原水水质栏目</span>
    </div>
    <div class="main">
      <div class="headerUnit">
        <span style="width: 60px">时间</span>
        <span style="width: 220px">浊度 （NTU）</span>
        <span style="width: 60px">PH</span>
      </div>
      <div class="dataWrap">
        <div class="tableItem" v-for="(item, index) in dataList" :key="item.id"
          :style="{ background: index % 2 == 0 ? 'rgba(0,115,255,0.11)' : 'rgba(0,80,186,0.10);' }">
          <span style="min-width: 60px">{{ item.time }}</span>
          <span style="min-width: 220px">{{ item.turbidity }}</span>
          <span style="min-width: 60px">{{ item.ph }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import chartResize from '@/mixin/chart-resize'
export default {
  name: 'FaultAlarm',
  components: {},
  data () {
    return {
      dataList: [
      ]
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.$http.get('/pipe-network/water_quality/screen-quality').then(res => {
        this.dataList = res.data[0].result
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 169px;
  width: 600px;
  background: url(~@/assets/myImg/h_10_ysszlm_box.png) no-repeat;
  background-size: contain;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    // top: -18px;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .main {
    padding: 0 10px;
    position: absolute;
    top: 30px;
    // float: left;
    height: 200px;
    width: 100%;

    .headerUnit {
      width: 100%;
      height: 30px;
      background-image: linear-gradient(270deg, rgba(7, 42, 80, 0.35) 0%, rgba(84, 169, 255, 0.25) 100%);
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      // text-align: center;

      span {
        text-align: left;
        display: block;
        margin-left: 10px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        color: #10c0ff;
        font-weight: 600;
      }
    }

    .dataWrap {
      // height: 318px;
      width: 100%;
      // padding: 0 10px;
      padding-bottom: 10px;
      // padding-top:20px;
      overflow-x: hidden;
      overflow-y: auto;

      .tableItem {
        height: 40px;
        width: 100%;
        min-height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        // text-align: center;
        .tableItemDiv {
          // min-width: 40px;
          // max-width: 60px;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 15px;
          color: #ffffff;
          font-weight: 600;

          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        span {
          display: inline-block;
          min-width: 40px;
          max-width: 200px;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 15px;
          color: #ffffff;
          font-weight: 600;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
